import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService {

    ASSETS_BLOG_IMAGE: string;

    public readonly MOTOR: number = 1;
    public readonly NONMOTOR: number = 2;
    // f09 Status
    public readonly updateRenewNonmotorTssSuccess: number = 40
    public readonly updateRenewNonmotorTssFail: number = 41
    public readonly updateRenewNonmotor: number = 42
    public readonly paySuccess: number = 50
    public readonly payFail: number = 51
    public readonly payProcessing: number = 52

    constructor() {
        //this.ASSETS_BLOG_IMAGE = './assets/images/blogs/';
        //this.ASSETS_BLOG_IMAGE = 'https://myprotection2.talpha.co/contents/images/blogs/';
        this.ASSETS_BLOG_IMAGE = '/contents/images/blogs/';
        //this.MOTOR = 1;
        //this.NONMOTOR = 2;
    }
}
